import { useQuery } from "@tanstack/react-query";
import { ToastService } from "@shared/lib/services";
import {
  BRIEF_CAMPAIGNS_LIST_QUERY_KEY,
  VENDOR_BILLING_QUERY_KEY,
} from "../contsants";
import { useEffect } from "react";
import { CampaignService } from "../services/Campaign.service";
import { IGetVendorBilling } from "@shared/lib/types/briefCampains";

export function useGetVendorBilling(influencerId: string) {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [...VENDOR_BILLING_QUERY_KEY("vendor-billing"), influencerId],
    queryFn: () => CampaignService.getVendorBilling(influencerId),
    enabled: !!influencerId,
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    vendorBilling: data?.data,
    isLoading,
    isError,
  };
}
